import { render, staticRenderFns } from "./TimeLine.vue?vue&type=template&id=20201f70&scoped=true&"
import script from "./TimeLine.vue?vue&type=script&lang=js&"
export * from "./TimeLine.vue?vue&type=script&lang=js&"
import style0 from "./TimeLine.vue?vue&type=style&index=0&id=20201f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20201f70",
  null
  
)

export default component.exports